"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8750],{

/***/ 28750:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function get() {
                        return e[k];
                    }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/ _interopNamespace(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
var genSize = function genSize(size) {
    switch(size){
        case "2xl":
            return "w-32 h-32";
        //512x512
        case "xl":
            return "w-16 h-16";
        //64x64
        case "lg":
            return "w-8 h-8";
        //32x32
        case "md":
            return "w-5 h-5";
        //20x20
        case "sm":
            return "w-4 h-4";
        //16x16
        case "xxs":
            return "w-2 h-2";
        //8x8
        case "xs":
        default:
            //Default must be the last
            return "w-3 h-3";
    }
};
var IconRenderer = function IconRenderer(_a) {
    var IconComponent = _a.IconComponent, _b = _a.size, size = _b === void 0 ? "md" : _b, color = _a.color, loadingStyle = _a.loadingStyle, className = _a.className, rest = __rest(_a, [
        "IconComponent",
        "size",
        "color",
        "loadingStyle",
        "className"
    ]);
    var sizeClass = size && genSize(size);
    var colorStyle = color ? {
        fill: color
    } : {};
    var loadingClass = loadingStyle && "animate-".concat(loadingStyle);
    return /*#__PURE__*/ React__default["default"].createElement(IconComponent, _extends({
        style: colorStyle,
        className: "".concat(color ? color : "fill-current", " ").concat(sizeClass ? sizeClass : "", " ").concat(loadingClass ? loadingClass : "", " ").concat(className ? className : "")
    }, rest));
};
var SvgArrowUp = function SvgArrowUp(props) {
    return /*#__PURE__*/ React__namespace.createElement("svg", _extends({
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 64 38"
    }, props), /*#__PURE__*/ React__namespace.createElement("path", {
        d: "M32 0l32 32.748-4.48 4.585L32 9.17 4.48 37.333 0 32.75 32 0z"
    }));
};
var ScrollTopButtonClassNames = "fixed z-1000 items-center justify-center bg-white border w-11 h-11 p-2 focus:outline-none border-scroll-to-top-cta-color shadow-modal";
var ScrollTopButton = function ScrollTopButton(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, children = _a.children;
    _a.id;
    var _c = _a.IconComponent, IconComponent = _c === void 0 ? SvgArrowUp : _c, _d = _a.iconSize, iconSize = _d === void 0 ? "md" : _d, _e = _a.color, color = _e === void 0 ? "#1E5F53" : _e, label = _a.label, _f = _a.scrollHeight, scrollHeight = _f === void 0 ? 300 : _f, _g = _a.positionBottom, positionBottom = _g === void 0 ? 0 : _g, _h = _a.positionRight, positionRight = _h === void 0 ? 0 : _h, rest = __rest(_a, [
        "className",
        "children",
        "id",
        "IconComponent",
        "iconSize",
        "color",
        "label",
        "scrollHeight",
        "positionBottom",
        "positionRight"
    ]);
    var _j = __read(React.useState(false), 2), visible = _j[0], setVisible = _j[1];
    var scrollToTop = function scrollToTop() {
        if (true) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    };
    React.useEffect(function() {
        var toggleVisible = function toggleVisible() {
            var scrolled = document.documentElement.scrollTop;
            if (scrolled > scrollHeight) {
                setVisible(true);
            } else if (scrolled <= scrollHeight) {
                setVisible(false);
            }
        };
        window === null || window === void 0 ? void 0 : window.addEventListener("scroll", toggleVisible);
        return function() {
            return window.removeEventListener("scroll", toggleVisible);
        };
    }, [
        scrollHeight
    ]);
    return /*#__PURE__*/ React__default["default"].createElement("button", _extends({
        type: "button",
        "aria-label": label,
        className: "".concat(className, " ").concat(ScrollTopButtonClassNames, " ").concat(visible ? "flex" : "hidden", " bottom-").concat(positionBottom, " right-").concat(positionRight),
        onClick: scrollToTop,
        "data-testid": visible ? "scrollToTopVisible" : "scrollToTopNotVisible"
    }, rest), /*#__PURE__*/ React__default["default"].createElement(IconRenderer, {
        IconComponent: IconComponent,
        size: iconSize,
        color: color
    }), children);
};
exports.ScrollTopButton = ScrollTopButton;
exports["default"] = ScrollTopButton; //# sourceMappingURL=ScrollTopButton.js.map


/***/ })

}]);